import {
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import React from 'react';

Chart.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const generateDynamicColors = (count) => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    // Generate a distinct hue with consistent saturation and brightness
    const hue = (i * 60) % 360; // adjust 60 for spacing between hues
    colors.push(`hsl(${hue}, 75%, 60%)`);
  }
  return colors;
};

const BarChartCommonComponent = ({ data }) => {
  const labels = data.map(item => item.label);
  const values = data.map(item => item.value);

  // generate colors based on number of bars
  const backgroundColors = generateDynamicColors(data.length);

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: backgroundColors,
        borderRadius: 6,
        barThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => `${context.raw}`,
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
        color: '#000',
        font: {
          size: 14,
          weight: 'bold',
        },
        formatter: (value) => (value ? value : ''),
      },
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: { display: false },
      },
      y: {
        grid: { display: false, drawBorder: false },
        ticks: { display: false },
        beginAtZero: true,
      },
    },
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        // height: '500px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '20px',
      }}
    >
      <div style={{ width: '100%' /*, height: '400px'*/ }}>
        <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
      </div>

      {/* Dynamic Legend */}
      <div
      className='row g-3 mt-0'
      >
        {data.map((item, index) => (
          <div className="col-auto">
            <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <div
              style={{
                width: '15px',
                height: '15px',
                backgroundColor: backgroundColors[index],
                borderRadius: '3px',
              }}
            />
            <span style={{ fontSize: '13px', color: '#333' }}>{item.label}</span>
          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BarChartCommonComponent;
